var introRotationInterval = null;
var introClickBound = false;

function updateLogoColor() {
  var introLogo = document.getElementById('intro-logo');
  var activeBlock = document.querySelector('.intro-image-container.active');
  if (activeBlock && introLogo && activeBlock.dataset.color) {
    introLogo.style.color = activeBlock.dataset.color;
  }
}

function rotateToNextIntro() {
  var containers = document.querySelectorAll('.intro-image-container');
  var activeContainer = document.querySelector('.intro-image-container.active');
  if (!activeContainer || containers.length === 0) return;
  var currentIndex = -1;
  containers.forEach(function(container, index) {
    if (container === activeContainer) currentIndex = index;
  });
  activeContainer.classList.remove('active');
  var nextIndex = (currentIndex + 1) % containers.length;
  containers[nextIndex].classList.add('active');
  // updateLogoColor();
}

function startIntroAnimation() {
  var containers = document.querySelectorAll('.intro-image-container');
  if (!containers.length) return;

  // updateLogoColor();

  requestAnimationFrame(function() {
    setTimeout(function() {
      document.body.classList.add('start-animation');
      setTimeout(function() {
        document.body.classList.add('show-nav');
      // }, 8500);
      // setTimeout(function() {
        document.body.classList.add('end-animation');
      }, 5000);
    }, 500);
  });

  if (introRotationInterval) clearInterval(introRotationInterval);
  introRotationInterval = setInterval(rotateToNextIntro, 800);
}

function initIntro() {
  var moduleHomepage = document.querySelector('.module-homepage-full');
  if (!moduleHomepage) return;

  if (!introClickBound) {
    introClickBound = true;
    moduleHomepage.addEventListener('click', function() {
      rotateToNextIntro();
    });
  }

  if (document.readyState === 'complete') {
    startIntroAnimation();
  } else {
    window.addEventListener('load', startIntroAnimation);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initIntro);
} else {
  initIntro();
}

window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    startIntroAnimation();
  }
});
